import { Divider, Stack } from 'braid-design-system';
import type { MDXContent } from 'mdx/types';
import React from 'react';

import { MarkdownTocSidebar } from './components/MarkdownToc.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';
import { PageNavigationButtonLinks } from '#src/components/PageNavigationButtonLinks/PageNavigationButtonLinks.tsx';
import { WrapperRenderer } from '#src/components/mdx/WrapperRenderer.tsx';
import type { PageNavigation } from '#src/docs.tsx';
import type { TableOfContents } from '#src/types.ts';

type MarkdownPageProps = {
  banner: React.JSX.Element | null;
  breadcrumbs: Breadcrumb[] | null;
  document: MDXContent;
  label: string;
  next?: PageNavigation;
  prev?: PageNavigation;
  toc: TableOfContents[];
};

export const MarkdownPage = ({
  banner,
  breadcrumbs,
  document,
  label,
  next,
  prev,
  toc,
}: MarkdownPageProps) => (
  <WrapperRenderer document={document}>
    {({ children }) => {
      // TODO: type better
      const [title, ...body]: any = React.Children.toArray(children);
      const titleChildren = title.props.children;

      return (
        <BasePage
          title={{
            children: titleChildren,
            stringTitle:
              typeof titleChildren === 'string' ? titleChildren : label,
          }}
          sidebar={<MarkdownTocSidebar toc={toc} />}
          breadcrumbs={breadcrumbs}
        >
          <Stack space="large">
            {banner}

            {body}
          </Stack>

          <Divider />

          <PageNavigationButtonLinks prev={prev} next={next} />
        </BasePage>
      );
    }}
  </WrapperRenderer>
);
